// import './file.scss';

export { default } from './File';
export { default as template } from './file.tpl';
